import React, { useEffect, useState } from "react";
import axios from "axios";

import "../App.css";

import { NavLink, useNavigate } from "react-router-dom";

import DistrictsJSON from "../data/districts.json";
import AmphuresJSON from "../data/amphures.json";
import ProvinceJSON from "../data/provinces.json";

// images
import Gift from "../images/gift.gif";
import Logo from "../images/25.png";

// components
import "antd/dist/antd.css";
import {
  Popconfirm,
  Button,
  Divider,
  Typography,
  Row,
  Affix,
  Badge,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Radio,
  AutoComplete,
  Modal,
  Checkbox,
} from "antd";

import moment from "moment";

import {
  FormOutlined,
  RightOutlined,
  LeftCircleOutlined,
  ShoppingOutlined,
  ClearOutlined,
} from "@ant-design/icons";

import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

const { Paragraph, Text, Title } = Typography;
const { Option } = Select;

function Info() {
  const Amphures_from = AmphuresJSON;
  const Province_from = ProvinceJSON;
  const SubDistricts_from = DistrictsJSON;

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const [form] = Form.useForm();
  let navigate = useNavigate();

  const [visible, setVisible] = useState(false);
  const [consent, setConsent] = useState(false);

  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(1);
  const [valueTaxInvoice, setValueTaxInvoice] = useState(2);

  const [select_District_from, setselect_District_from] = useState([]);
  const [select_SubDistrict_from, setselect_SubDistrict_from] = useState([]);

  const [gift, setGift] = useState(null);

  useEffect(() => {
    setLoading(true);

    checkStatusWeb();
    getData();
    getGifts();

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const checkStatusWeb = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "control_web"), where("isactive", "==", false))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0) {
      navigate("/maintain");
    }
  };

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    // console.log('Clicked cancel button');
    setVisible(false);
  };

  const getGifts = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "gift"), where("isactive", "==", true))
    );
    const gift = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (gift.length === 0) {
      setGift(null);
    } else {
      setGift(
        gift.sort((a, b) => {
          if (a.condition < b.condition) {
            return -1;
          }
        })
      );
    }
  };

  const selected_District_from = (e) => {
    var id = 0;
    var i = 0;

    for (i = 0; i < Province_from.length; i++) {
      if (Province_from[i].value == e) {
        id = Province_from[i].province_id;
      }
    }
    var obj = [];
    var num = Amphures_from.length;
    for (i = 0; i < num; i++) {
      if (Amphures_from[i].province_id == id) {
        obj.push({
          province_id: Amphures_from[i].province_id,
          value:
            Amphures_from[i].value + " /" + Amphures_from[i].amphur_name_eng,
        });
      }
    }

    return obj;
  };

  const selected_SubDistrict_from = (e) => {
    var id = 0;
    var i = 0;
    var stre = e;
    var res = stre.split(" ", 1);

    for (i = 0; i < Amphures_from.length; i++) {
      // console.log('arr res',res)
      if (Amphures_from[i].value == res) {
        id = Amphures_from[i].amphur_id;
      }
    }
    var obj = [];
    var num = SubDistricts_from.length;
    var Amphures_from_id = id;
    for (i = 0; i < num; i++) {
      if (SubDistricts_from[i].amphur_id == id) {
        obj.push({
          amphur_id: SubDistricts_from[i].amphur_id,
          value:
            SubDistricts_from[i].value +
            " /" +
            SubDistricts_from[i].district_name_eng,
        });
      }
    }
    return obj;
  };

  const getData = async () => {
    if (
      JSON.parse(localStorage.getItem("Cart")) &&
      JSON.parse(localStorage.getItem("Cart")).length !== 0
    ) {
      const querySnapshot = await getDocs(
        query(collection(db, "packages"), where("isactive", "==", true))
      );
      const allPack = querySnapshot.docs.map((doc) => doc.data());

      const cartPack = JSON.parse(localStorage.getItem("Cart")).filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss") &&
          x.isactive === true
      );

      // console.log(cartPack)

      // mapping สำหรับแพ็คเกจที่ไม่ได้อยู่ใน DB (hardcoded)
      const codeMap = {
        // ถ้ามีการใช้ 26Pro06 ให้ถือว่าเทียบเท่ากับ 26Pro01 ที่อยู่ใน DB
        "26Pro06": "26Pro01",
      };

      let arr = [];
      for (let i = 0; i < allPack.length; i++) {
        for (let j = 0; j < cartPack.length; j++) {
          const cartCode = cartPack[j].ecoupon_code;
          const normalizedCartCode = codeMap[cartCode] ? codeMap[cartCode] : cartCode;

          if (
            allPack[i].ecoupon_code === normalizedCartCode &&
            allPack[i].isactive === cartPack[j].isactive &&
            allPack[i].start_date === cartPack[j].start_date &&
            allPack[i].end_date === cartPack[j].end_date
          ) {
            // เก็บรายการจาก localStorage (ไม่เปลี่ยน ecoupon_code ที่ผู้ใช้เห็น)
            arr.push(cartPack[j]);
          }
        }
      }

      if (arr.length !== 0) {
        showInfo();
        setCart(arr);
        localStorage.removeItem("Cart");
        localStorage.setItem("Cart", JSON.stringify(arr));
      } else {
        navigate("/");
      }
    } else {
      navigate("/");
    }
  };

  const onFinish = (values) => {
    // console.log(values.channel)
    if(values.channel !== undefined && values.channel.length !== 0){
      values.channel = values.channel.join(',');
    }else{
      values.channel = ""
    }
    values.dob = moment(values.dob).format("YYYY-MM-DD");
    localStorage.setItem("Info", JSON.stringify(values));
    navigate("/order");
  };

  const showInfo = () => {
    form.setFieldsValue({
      identification_number: 1,
    });

    form.setFieldsValue({
      tax_invoice: 2,
    });

    const info = JSON.parse(localStorage.getItem("Info"));
    if (info) {
      form.setFieldsValue({ prename: info.prename });
      form.setFieldsValue({ firstname: info.firstname });
      form.setFieldsValue({ lastname: info.lastname });
      form.setFieldsValue({ dob: moment(info.dob) });
      form.setFieldsValue({ idcard: info.idcard });
      form.setFieldsValue({ passport: info.passport });
      form.setFieldsValue({ email: info.email });
      form.setFieldsValue({ tel: info.tel });
      form.setFieldsValue({
        identification_number: info.identification_number,
      });
      setValue(info.identification_number);
      form.setFieldsValue({
        tax_invoice: info.tax_invoice,
      });
      setValueTaxInvoice(info.tax_invoice);

      form.setFieldsValue({ house_no: info.house_no });
      form.setFieldsValue({ village_no: info.village_no });
      form.setFieldsValue({ lane: info.lane });
      form.setFieldsValue({ road: info.road });
      form.setFieldsValue({ sub_district: info.sub_district });
      form.setFieldsValue({ district: info.district });
      form.setFieldsValue({ province: info.province });
      form.setFieldsValue({ postal_code: info.postal_code });

      if (info.tax_invoice === 1) {
        form.setFieldsValue({ tax_company_name: info.tax_company_name });
        form.setFieldsValue({ tax_payer_no: info.tax_payer_no });
        form.setFieldsValue({ tax_house_no: info.tax_house_no });
        form.setFieldsValue({ tax_village_no: info.tax_village_no });
        form.setFieldsValue({ tax_lane: info.tax_lane });
        form.setFieldsValue({ tax_road: info.tax_road });
        form.setFieldsValue({ tax_sub_district: info.tax_sub_district });
        form.setFieldsValue({ tax_district: info.tax_district });
        form.setFieldsValue({ tax_province: info.tax_province });
        form.setFieldsValue({ tax_postal_code: info.tax_postal_code });
      }
    } else {
      const profile = JSON.parse(localStorage.getItem("Profile"));
      if (profile) {
        form.setFieldsValue({ prename: profile.prename });
        form.setFieldsValue({ firstname: profile.firstname });
        form.setFieldsValue({ lastname: profile.lastname });
        form.setFieldsValue({ dob: moment(profile.birthdate) });
        form.setFieldsValue({ idcard: profile.pid });
        form.setFieldsValue({ email: profile.email });
        form.setFieldsValue({ tel: profile.phone });
      }
    }

    const sandConnect = localStorage.getItem("SandConnect");
    if (sandConnect) {
      form.setFieldsValue({ channel: ['Sand Connect'] });
    }

    const refcode = JSON.parse(localStorage.getItem("RefCode"));
    if (refcode) {
      form.setFieldsValue({ referral_code: refcode });
      form.setFieldsValue({ channel: ['พนักงานแนะนำ'] });
    }
    else{
      const profile = JSON.parse(localStorage.getItem("Profile"));
      if (profile) {
        if(profile.staff_id !== null){
          form.setFieldsValue({ referral_code: profile.staff_id });
          form.setFieldsValue({ channel: ['พนักงานแนะนำ'] });
        }
      }
    }
    
  };

  const onChange = (e) => {
    // localStorage.setItem("Radio", JSON.stringify(e.target.value));
    setValue(e.target.value);
  };

  const onChangeTaxInvoice = (e) => {
    // localStorage.setItem("TaxInvoice", JSON.stringify(e.target.value));
    setValueTaxInvoice(e.target.value);
  };

  const resetForm = () => {
    form.resetFields();
    const refcode = JSON.parse(localStorage.getItem("RefCode"));
    if (refcode) {
      form.setFieldsValue({ referral_code: refcode });
      form.setFieldsValue({ channel: ['พนักงานแนะนำ'] });
    }
  };

  const Loading = () => {
    return (
      <div className="center">
        <img src={Gift} style={{ width: "20%" }} />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col style={{ textAlign: "left" }}>
                <LeftCircleOutlined
                  style={{
                    fontSize: "20px",
                    marginTop: "10px",
                    marginRight: "20px",
                    color: "#1e366f",
                  }}
                  onClick={() => window.history.back()}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <NavLink to="/cart">
                  <Badge
                    count={
                      cart != null
                        ? cart.filter((x) => x.type !== "option").length
                        : null
                    }
                  >
                    <div style={{ background: "white", borderRadius: "25px" }}>
                      <ShoppingOutlined
                        style={{
                          color: "#1e366f",
                          fontSize: "28px",
                          padding: "7px",
                        }}
                      />
                    </div>
                  </Badge>
                </NavLink>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div style={{ padding: "20px" }}>
            <Row>
              <Col span={12}>
                <Title level={5}>
                  <FormOutlined style={{ marginRight: "5px" }} />{" "}
                  กรอกข้อมูลชำระเงิน
                </Title>
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <Popconfirm
                  placement="bottomRight"
                  title="คุณต้องการล้างข้อมูลหรือไม่ ​?"
                  onConfirm={() => resetForm()}
                  okText="ใช่"
                  cancelText="ไม่"
                >
                  <Button type="primary" ghost size="small">
                    <ClearOutlined />
                    ล้างข้อมูล
                  </Button>
                </Popconfirm>
              </Col>
            </Row>
            <Divider style={{ background: "black", marginTop: "16px" }} />
            <Form
              form={form}
              name="control-hooks"
              onFinish={onFinish}
              autoComplete="off"
              {...layout}
            >
              <Form.Item
                name="prename"
                label="Prename(คำนำหน้า)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="Prename">
                  <Option value="นาย">นาย/Mr.</Option>
                  <Option value="นางสาว">นางสาว/Miss</Option>
                  <Option value="นาง">นาง/Mrs.</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="firstname"
                label="Firstname(ชื่อจริง)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Firstname" />
              </Form.Item>
              <Form.Item
                name="lastname"
                label="Lastname(นามสกุล)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Lastname" />
              </Form.Item>
              <Form.Item
                name="dob"
                label="Date of Birth(วันเกิด)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  format="YYYY-MM-DD"
                  inputReadOnly={true}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    let customDate = moment().format("YYYY-MM-DD");
                    return (
                      current && current > moment(customDate, "YYYY-MM-DD")
                    );
                  }}
                />
              </Form.Item>

              <Form.Item
                name="identification_number"
                label="Identification number(หมายเลขระบุตัวตน)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group onChange={onChange} value={value}>
                  <Radio value={1}>ID card(บัตรประชาชน)</Radio>
                  <Radio value={2}>Passport(เลขที่หนังสือเดินทาง)</Radio>
                </Radio.Group>
              </Form.Item>

              {value == 1 ? (
                <Form.Item
                  name="idcard"
                  label="ID card(บัตรประชาชน)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input
                    placeholder="ID card"
                    minLength={13}
                    maxLength={13}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  name="passport"
                  label="Passport(เลขที่หนังสือเดินทาง)"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input placeholder="Passport" />
                </Form.Item>
              )}
              <Form.Item
                name="email"
                label="Email(อีเมลล์)  **สำหรับส่ง link ชำระเงิน"
                rules={[
                  {
                    required: true,
                    type: "email",
                  },
                ]}
              >
                <Input placeholder="E-mail" />
              </Form.Item>

              <Form.Item
                name="tel"
                label="Phone(เบอร์โทรศัพท์) **สำหรับส่ง link ชำระเงิน"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder="Tel."
                  maxLength={10}
                  minLength={10}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </Form.Item>

              <Form.Item
                name="channel"
                label="Awareness channel(ช่องทางการรับรู้)"
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Checkbox.Group
                  style={{
                    width: "100%",
                  }}
                >
                  <Row>
                    <Col span={12}>
                      <Checkbox value="Facebook">Facebook</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="Line Official">Line Official</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="Tiktok">Tiktok</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="Instagram">Instagram</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="Sand Connect">Sand Connect</Checkbox>
                    </Col>
                    <Col span={12}>
                      <Checkbox value="พนักงานแนะนำ">พนักงานแนะนำ</Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Form.Item>

              <Form.Item
                name="referral_code"
                label="Referral code(รหัสแนะนำ)"
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Input
                  placeholder="Referral code"
                  // onKeyPress={(event) => {
                  //   if (!/[0-9]/.test(event.key)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                />
              </Form.Item>
              {/* <br/> */}

              {cart != null && gift != null ? (
                cart.reduce((accumulator, object) => {
                  return accumulator + object.price_pro * object.qty;
                }, 0) >= gift[0].condition ? (
                  <div style={{ marginTop: "40px" }}>
                    <Title level={5}>
                      <FormOutlined style={{ marginRight: "5px" }} /> ที่อยู่
                      (สำหรับจัดส่งของสัมนาคุณ)
                    </Title>
                    <Divider style={{ background: "black" }} />
                    <Form
                      form={form}
                      name="control-hooks"
                      onFinish={onFinish}
                      autoComplete="off"
                      {...layout}
                    >
                      <Form.Item
                        name="house_no"
                        label="House no(บ้านเลขที่)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder="House no" />
                      </Form.Item>
                      <Form.Item
                        name="village_no"
                        label="Village no(หมู่ที่)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder="Village no" />
                      </Form.Item>
                      <Form.Item
                        name="lane"
                        label="Lane(ซอย)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder="Lane" />
                      </Form.Item>
                      <Form.Item
                        name="road"
                        label="Road(ถนน)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Input placeholder="Road" />
                      </Form.Item>

                      <Form.Item
                        name="province"
                        label="Province(จังหวัด)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <AutoComplete
                          onSelect={(e) =>
                            setselect_District_from(selected_District_from(e))
                          }
                          options={Province_from}
                          placeholder="Province"
                          filterOption={(inputValue, option) =>
                            option.value.indexOf(inputValue) !== -1
                          }
                        />
                      </Form.Item>
                      <Form.Item
                        name="district"
                        label="District(อำเภอ)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <AutoComplete
                          onSelect={(e) =>
                            setselect_SubDistrict_from(
                              selected_SubDistrict_from(e)
                            )
                          }
                          options={select_District_from}
                          placeholder="District"
                          filterOption={(inputValue, option) =>
                            option.value.indexOf(inputValue) !== -1
                          }
                        ></AutoComplete>
                      </Form.Item>
                      <Form.Item
                        name="sub_district"
                        label="Sub district(ตำบล)"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <AutoComplete
                          options={select_SubDistrict_from}
                          placeholder="Sub district"
                          filterOption={(inputValue, option) =>
                            option.value.indexOf(inputValue) !== -1
                          }
                        ></AutoComplete>
                      </Form.Item>
                      <Form.Item
                        name="postal_code"
                        label="Postal code(รหัสไปรษณีย์)"
                        rules={[
                          {
                            required: true,
                            // message:'กรุณ'
                          },
                        ]}
                      >
                        <Input
                          placeholder="Postal code"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Form>
                  </div>
                ) : null
              ) : null}

              <br />

              <Form.Item
                name="tax_invoice"
                label="คุณต้องการใบเสร็จในนามบริษัทหรือไม่ ?"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Radio.Group
                  onChange={onChangeTaxInvoice}
                  value={valueTaxInvoice}
                >
                  <Radio value={1}>ต้องการ</Radio>
                  <Radio value={2}>ไม่ต้องการ</Radio>
                </Radio.Group>
              </Form.Item>

              {valueTaxInvoice === 1 ? (
                <>
                  <Form.Item
                    name="tax_company_name"
                    label="Company name(ชื่อบริษัท)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="Company name" />
                  </Form.Item>

                  <Form.Item
                    name="tax_payer_no"
                    label="Tax No.(หมายเลขผู้เสียภาษี)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      placeholder="Tax No."
                      minLength={13}
                      maxLength={13}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="tax_house_no"
                    label="House no(บ้านเลขที่)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="House no" />
                  </Form.Item>
                  <Form.Item
                    name="tax_village_no"
                    label="Village no(หมู่ที่)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="Village no" />
                  </Form.Item>
                  <Form.Item
                    name="tax_lane"
                    label="Lane(ซอย)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="Lane" />
                  </Form.Item>
                  <Form.Item
                    name="tax_road"
                    label="Road(ถนน)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input placeholder="Road" />
                  </Form.Item>

                  <Form.Item
                    name="tax_province"
                    label="Province(จังหวัด)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <AutoComplete
                      onSelect={(e) =>
                        setselect_District_from(selected_District_from(e))
                      }
                      options={Province_from}
                      placeholder="Province"
                      filterOption={(inputValue, option) =>
                        option.value.indexOf(inputValue) !== -1
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name="tax_district"
                    label="District(อำเภอ)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <AutoComplete
                      onSelect={(e) =>
                        setselect_SubDistrict_from(selected_SubDistrict_from(e))
                      }
                      options={select_District_from}
                      placeholder="District"
                      filterOption={(inputValue, option) =>
                        option.value.indexOf(inputValue) !== -1
                      }
                    ></AutoComplete>
                  </Form.Item>
                  <Form.Item
                    name="tax_sub_district"
                    label="Sub district(ตำบล)"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <AutoComplete
                      options={select_SubDistrict_from}
                      placeholder="Sub district"
                      filterOption={(inputValue, option) =>
                        option.value.indexOf(inputValue) !== -1
                      }
                    ></AutoComplete>
                  </Form.Item>
                  <Form.Item
                    name="tax_postal_code"
                    label="Postal code(รหัสไปรษณีย์)"
                    rules={[
                      {
                        required: true,
                        // message:'กรุณ'
                      },
                    ]}
                  >
                    <Input
                      placeholder="Postal code"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </>
              ) : null}

              <Checkbox
                onChange={(e) => setConsent(e.target.checked)}
                value={consent}
              >
                <Button
                  type="link"
                  onClick={showModal}
                  style={{
                    whiteSpace: "normal",
                    height: "auto",
                    margin: "0px 0 20px -5px ",
                    textAlign: "left",
                  }}
                >
                  <i>
                    คุณได้อ่านและยอมรับเงื่อนไขการใช้บริการและ
                    <u>นโยบายคุ้มครองความเป็นส่วนตัว</u>
                  </i>
                </Button>
              </Checkbox>

              <Form.Item style={{ textAlign: "right" }}>
                <Button
                  style={{ color: "#1e366f", borderColor: "#1e366f" }}
                  shape="round"
                  type="primary"
                  ghost
                  htmlType="submit"
                  disabled={!consent}
                >
                  ถัดไป <RightOutlined />
                </Button>
              </Form.Item>
            </Form>
          </div>
        </>
      )}

      <Modal
        title="นโยบายคุ้มครองข้อมูลส่วนบุคคล"
        visible={visible}
        onCancel={handleCancel}
        width={700}
        footer={null}
      >
        <Paragraph>
          บริษัท โรงพยาบาลกรุงเทพหาดใหญ่ จำกัด หรือ โรงพยาบาลกรุงเทพหาดใหญ่
          คุ้มครองข้อมูลส่วนบุคคลของท่านตามข้อกำหนดกฎหมาย
          และมีแนวทางดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านตามนโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้
          การให้ข้อมูลส่วนบุคคลโดยระบุข้อมูลหรือทำเครื่องหมายลงแบบฟอร์มเพื่อการติดต่อหรือรับบริการกับโรงพยาบาลกรุงเทพหาดใหญ่
          ในระหว่างเยี่ยมชมหรือใช้เว็บไซต์
          หรือแอพพลิเคชั่นที่โรงพยาบาลกรุงเทพหาดใหญ่ใช้ให้บริการ
          ถือว่าท่านได้ยินยอมและตกลงด้วยกับนโยบายคุ้มครองข้อมูลส่วนบุคคลด้วยแล้ว
          ดังรายละเอียดต่อไปนี้
          <br />
          <Divider />
          <Text strong>ข้อมูลที่จัดเก็บรวบรวม </Text>
          <br />
          โรงพยาบาลกรุงเทพหาดใหญ่จะจัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเท่าที่จำเป็น
          ตามที่ท่านให้ไว้สำหรับการรับบริการต่าง ๆ ของโรงพยาบาลกรุงเทพหาดใหญ่
          ตัวอย่างเช่น การให้ข้อมูลส่วนบุคคลเพื่อการรับข่าวสาร การสอบถามข้อมูล
          การนัดหมายแพทย์ การรับบริการระบบแพทย์ทางไกล (Telemedicine)
          การรับบริการปรึกษาแพทย์ออนไลน์ (Online Consulting Service)
          การชำระเงินออนไลน์ เป็นต้น
          ทั้งนี้ท่านอาจเลือกที่จะไม่ให้ข้อมูลส่วนบุคคลแก่โรงพยาบาลกรุงเทพหาดใหญ่ก็ได้
          แต่จะมีผลให้โรงพยาบาลกรุงเทพหาดใหญ่อาจจะไม่สามารถให้บริการแก่ท่านได้อย่างถูกต้องสมบูรณ์
          <br />
          <Divider />
          <Text strong>การใช้ข้อมูลส่วนบุคคล </Text> <br />
          โรงพยาบาลกรุงเทพหาดใหญ่จะใช้ข้อมูลส่วนบุคคลของท่านเท่าที่จำเป็น
          เพื่อการติดต่อหรือให้บริการท่าน
          รวมถึงการประชาสัมพันธ์หรือแจ้งข้อมูลข่าวสาร
          และอาจใช้เพื่อประโยชน์ด้านการศึกษาวิจัยหรือทางสถิติ
          ตลอดจนเพื่อการพัฒนามาตรฐานบริการมาตรการรักษาความปลอดภัยของข้อมูลที่เหมาะสม
          การเปิดเผยข้อมูลส่วนบุคคล
          <br />
          ข้อมูลส่วนบุคคลของท่านที่โรงพยาบาลกรุงเทพหาดใหญ่ได้บันทึกจัดเก็บไว้
          อาจมีการเปิดเผยให้แก่บุคคลภายนอก กรณีดังต่อไปนี้
          <br />
          1. การเปิดเผยหรือส่งต่อไปยังบุคคลภายนอก
          ซึ่งมีส่วนเกี่ยวข้องกับการให้บริการแก่ท่าน ได้แก่
          บริษัทประกันภัยผู้ให้บริการคุ้มครองสิทธิค่าบริการรักษาพยาบาลของท่าน
          ธนาคารผู้ให้บริการรับชำระเงินค่าบริการผ่านทางออนไลน์
          หรือบริษัทผู้สนับสนุนการให้บริการอื่น ๆ
          ที่จำเป็นสำหรับการให้บริการของโรงพยาบาลกรุงเทพหาดใหญ่
          <br />
          2. การจ้างบริษัทหรือบุคคลภายนอกเพื่อการวิเคราะห์ข้อมูล
          บริการจัดการข้อมูล พัฒนาเว็บไซต์หรือแอพพลิเคชั่น
          ตลอดจนการร่วมพัฒนาบริการ และ/หรือ
          ทำการตลาดร่วมกันกับโรงพยาบาลกรุงเทพหาดใหญ่
          โดยบริษัทหรือบุคคลภายนอกที่เกี่ยวข้องดังกล่าวจะได้รับอนุญาตให้เข้าใช้ข้อมูลส่วนบุคคลของท่านที่จำเป็นในการปฏิบัติหน้าที่หรือดำเนินงาน
          และต้องอยู่ภายใต้บังคับสัญญาที่รักษาความลับของข้อมูลและเป็นไปตามข้อกำหนดกฎหมาย
          <br />
          3.
          การส่งต่อข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์โดยชอบด้วยกฎหมายของบุคคลภายนอก
          หรือเพื่อสาธารณประโยชน์ รวมถึงเพื่อการป้องกันการทุจริต
          การโจรกรรมข้อมูล การโจมตีทางไซเบอร์ การปรับปรุงคุณภาพการให้บริการ
          หรือเพื่อการดำเนินการทางกฎหมาย การเชื่อมโยงเว็บไซต์อื่น
          <br />
          เว็บไซต์ของโรงพยาบาลกรุงเทพหาดใหญ่ อาจมีการเชื่อมโยงไปยังเว็บไซต์อื่น
          หากท่านได้ติดต่อหรือใช้เว็บไซต์อื่นที่ได้เชื่อมโยงดังกล่าว
          นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้จะไม่ครอบคลุมเว็บไซต์ดังกล่าวนั้น
          และโรงพยาบาลกรุงเทพหาดใหญ่ไม่มีส่วนเกี่ยวข้องในความรับผิดใด ๆ
          ที่อาจเกิดขึ้นจากการไม่ได้ปฏิบัติหรือดำเนินการเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของท่าน
          ระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคล
          ข้อมูลส่วนบุคคลของท่านจะถูกเก็บรักษาไว้นานเท่าที่จำเป็น
          ตามวัตถุประสงค์การบันทึกจัดเก็บและใช้ข้อมูลส่วนบุคคลของท่านข้างต้น
          หรือภายใต้ข้อบังคับของกฎหมาย หรือเพื่อการดำเนินการทางกฎหมาย
          การรักษาความปลอดภัยข้อมูลส่วนบุคคล
          โรงพยาบาลกรุงเทพหาดใหญ่ใช้มาตรการรักษาความปลอดภัยข้อมูลส่วนบุคคลของท่าน
          ที่มีเทคนิค ขั้นตอน
          และการบริหารจัดการที่เหมาะสมตามที่กำหนดไว้ในกฎหมายที่เกี่ยวข้อง
          เพื่อป้องกันการเข้าใช้ ดัดแปลง แก้ไข เปิดเผย
          หรือกระทำการอื่นใดเกี่ยวกับข้อมูลส่วนบุคคลของท่านโดยไม่ได้รับอนุญาตหรือไม่ชอบด้วยกฎหมาย
          อย่างไรก็ดีมาตรการรักษาความปลอดภัยข้อมูลส่วนบุคคลดังกล่าวอาจมีความสมบูรณ์ไม่เต็ม
          100%
          อาจมีข้อบกพร่องจากการทำงานของระบบเทคนิคที่มิอาจควบคุมได้เป็นครั้งคราว
          ฉะนั้นโรงพยาบาลกรุงเทพหาดใหญ่ไม่รับประกันหรือรับรองประสิทธิภาพของมาตรการที่ใช้รักษาความปลอดภัยข้อมูลส่วนบุคคลของท่าน
          สิทธิความคุ้มครองข้อมูลส่วนบุคคล โปรดทราบว่าท่านมีสิทธิที่จะขอสำเนา
          แก้ไขให้ถูกต้องสมบูรณ์เป็นปัจจุบัน
          หรือใช้สิทธิอื่นใดภายใต้ความคุ้มครองทางกฎหมาย
          เมื่อท่านต้องการใช้สิทธินี้สามารถแสดงความจำนงค์ตามช่องทางการติดต่อด้านล่าง
          ช่องทางการติดต่อเรา
          ท่านสามารถติดต่อเพื่อใช้สิทธิความคุ้มครองข้อมูลส่วนบุคคล
          โดยจัดส่งเป็นหนังสือพร้อมแนบสำเนาหลักฐานแสดงตัวตนของท่าน
          ตามที่อยู่ดังนี้ 75 ซอยเพชรเกษม15 ถนนเพชรเกษม ตำบลหาดใหญ่ อำเภอหาดใหญ่
          จังหวัดสงขลา 90110 ประเทศไทย กรณีท่านมีคำถาม ข้อเสนอแนะเพิ่มเติม
          เกี่ยวกับนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้
          <br />
          ติดต่อได้ที่
          <a> E-mail : bhhinfo@bdms.co.th </a>
          หมายเลขโทรศัพท์ 074 272 800
          <Divider />
          <Text strong>การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล</Text>
          <br />
          โรงพยาบาลกรุงเทพหาดใหญ่อาจแก้ไขเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้เป็นครั้งคราวโดยไม่ได้แจ้งให้ท่านทราบล่วงหน้า
          เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของการให้บริการและการดำเนินงาน
          หรือข้อเสนอแนะจากท่าน รวมถึงข้อกฎหมายที่เกี่ยวข้อง
          การแก้ไขนโยบายคุ้มครองข้อมูลส่วนบุคคลมีผลใช้บังคับทันทีที่มีการประกาศ
          ซึ่งนับตั้งแต่วันที่ดังระบุไว้ด้านล่าง
          ดังนั้นโรงพยาบาลกรุงเทพหาดใหญ่จึงขอแนะนำให้ท่านอ่านนโยบายคุ้มครองข้อมูลส่วนบุคคลทุกครั้งที่เยี่ยมชมหรือเข้าใช้
          เว็บไซต์หรือแอพพลิเคชั่นที่โรงพยาบาลกรุงเทพหาดใหญ่ใช้ให้บริการ
        </Paragraph>
      </Modal>
    </div>
  );
}

export default Info;
